// extracted by mini-css-extract-plugin
export var localeSelector = "_6b-0";